/* eslint-disable no-unused-vars */
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Box } from "@mui/system";
import PropTypes from "prop-types";
import React from "react";
import { CSVLink } from "react-csv";
import { useLocation, useParams } from "react-router-dom";
import swal from "sweetalert";
import {
  CreateVendorContact,
  GetAllActiveBranches,
  GetVendorContact,
  StatusChangeVendorContact,
  UpdateVendorContact,
} from "../../../axios";
import {
  AddIcon,
  AlertMessage,
  BreadCrumbs,
  Chip,
  DownloadIcon,
  IconButton,
  Modal,
  NodataFound,
  SwitchButton,
} from "../../../components";
import LoaderComponent from "../../../components/common/Loader";
import { VendorContactForm } from "../../../forms";
import "../../../styles/tablepagination.css";
import { default as Strings, default as strings } from "../../../translations";
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from "@mui/icons-material";

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}


const headCells = [
  {
    id: "clientName",
    numeric: false,
    disablePadding: false,
    label: Strings["VenderContactForm.BranchNameLabel"],
  },
  {
    id: "designation",
    numeric: false,
    disablePadding: false,
    label: Strings["TableHead.designation"],
  },
  {
    id: "phone",
    numeric: false,
    disablePadding: false,
    label: Strings["VenderManagement.TableHead.tel"],
  },
  {
    id: "Active Status",
    numeric: false,
    disablePadding: false,
    label: Strings["Status.TableHead.activeStatus"],
  },
  {
    id: "Actions",
    numeric: true,
    disablePadding: false,
    label: Strings["Status.TableHead.action"],
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox"></TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: "1 1 100%" }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Nutrition
        </Typography>
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton>
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function SearchVendorContactPage() {

  const
    alertMessage = Strings["ItemGroup.AlertMessage"],
    alertTitle = Strings["ItemGroup.AlertTitle"],
    ContactLable = Strings["VendorContact.DashboardVendorTitle"];


  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [isOpen, setIsOpen] = React.useState(false);
  const [clickedBtn, setClickedBtn] = React.useState("");
  const [currentClientContact, setCurrentClientContact] = React.useState({});
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [errorMessage, setMessage] = React.useState(null);
  const [alertBox, setAlertBox] = React.useState(false);
  const [statusChangeId, setStatusChangeId] = React.useState(null);
  const [statusCode, setStatusCode] = React.useState();
  const [isLoader, setisLoader] = React.useState(false);
  const [branchOptions, setBranchOptions] = React.useState([]);
  const location = useLocation();
  const allData = location.state;
  const vendorId = allData.id;

  const paths = [
    {
      name: Strings["MasterConfigurationText"],
      path: "master-configuration",
    },
    {
      name: Strings["Navigation.SideBarVendor"],
      path: "master-configuration/vendor",
    },
    {
      name: strings["VendorProfile"],
      path: "master-configuration/vendorprofile",
    },
    {
      name: strings["Contacts"],
      path: "",
    },
  ];

  const handleChangeActiveStatus = (row) => {
    setStatusCode(row.is_active);
    setStatusChangeId(row.id);
    setAlertBox(true);
  };

  const handleChangeCancel = () => {
    setAlertBox(false);
  };

  const getVendorContact = () => {
    setLoading(true);
    GetVendorContact(vendorId)
      .then((res) => {
        setLoading(false);
        setRows(res.data.data);
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response.data.message);
      });
  };
  React.useEffect(() => {
    GetAllActiveBranches()
      .then((res) => {
        const allBranch = res.data.data;
        const result = allBranch.map((ele) => ({
          key: ele.id,
          value: ele.id,
          label: ele.name,
        }));
        setBranchOptions(result);
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response.data.message);
      });
  }, []);
  React.useEffect(() => {
    getVendorContact();
  }, []);

  const handleChangeSuccess = () => {
    StatusChangeVendorContact(
      { status: statusCode === 1 ? 0 : 1 },
      statusChangeId
    )
      .then((res) => {
        setisLoader(false);
        getVendorContact();
        setAlertBox(false);
      })
      .catch((e) => {
        setisLoader(false);
        setMessage(e.response.data.message);
      });
  };

  const openAddModal = () => {
    setIsOpen(true);
  };
  const handleModalClose = () => {
    setIsOpen(false);
  };

  const handleSelectBtn = (btn) => {
    setClickedBtn(btn);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;
  const createContact = (formData) => {
    setLoading(true);
    CreateVendorContact(formData)
      .then((res) => {
        setRows([res.data.data, ...rows]);
        swal({
          title: "Success!",
          text: res.data.message,
          icon: "success",
        });
        setLoading(false);
        handleModalClose();
      })
      .catch((e) => {
        setLoading(false);
        setMessage(e.response.data.message);
      });
  };
  const updateContact = (formData) => {
    let id = currentClientContact.id;
    UpdateVendorContact(formData, id)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          swal({
            title: "Success!",
            text: res.data.message,
            icon: "success",
          });
        }
        getVendorContact();
        handleModalClose();
      })
      .catch((e) => {
        setLoading(false);
        setMessage(e.response.data.message);
      });
  };

  const selectModal = () => {
    return (
      <VendorContactForm
        vendorId={vendorId}
        errorMessage={errorMessage}
        setMessage={setMessage}
        branchOptions={branchOptions}
        handleChangeFormData={
          clickedBtn === "add" ? createContact : updateContact
        }
        initialValue={clickedBtn === "add" ? {} : currentClientContact}
        actionType={clickedBtn}
        handleModalClose={handleModalClose}
      />
    );
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  const headers = [
    { label: "Name", key: "name" },
    { label: "Designation", key: "designation" },
    { label: "Phone No.", key: "phone" },
  ];
  const csvReport = {
    data: rows,
    headers: headers,
    filename: "Vendorscontact_Report.csv",
  };

  function CustomTablePaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
  
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };
  
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };
  
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };
  
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
  
    return (
      <div style={{ flexShrink: 0, marginLeft: '1rem' }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          <FirstPage />
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          <KeyboardArrowRight />
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          <LastPage />
        </IconButton>
      </div>
    );
  }

  return (
    <div className="container">
      {loading ? <LoaderComponent /> : null}
      <Modal onHandleClose={handleModalClose} isOpen={isOpen}>
        {selectModal()}
      </Modal>
      <div className="row mt-3">
        <div className="col-5">
          <h3>{ContactLable} </h3>
          <BreadCrumbs pathList={paths} obj={allData} />
        </div>
        <div
          className="col-7"
          style={{
            marginTop: "20px",
            textAlign: "end",
            marginBottom: 20,
          }}
        >
          {alertBox && (
            <AlertMessage
              title={alertTitle}
              message={alertMessage}
              onChangeCancel={handleChangeCancel}
              onChangeSucess={handleChangeSuccess}
            />
          )}
          <div>
            <span className="downloadButton mx-3">
              <CSVLink style={{ color: "white" }} {...csvReport}>
                <IconButton>
                  <DownloadIcon />
                </IconButton>
              </CSVLink>
            </span>
            <span className="addButton">
              <IconButton
                onClick={() => {
                  openAddModal();
                  handleSelectBtn("add");
                }}
              >
                <AddIcon />
              </IconButton>
            </span>
          </div>
        </div>
        {rows.length > 0 ? (
          <>
            <Box
              style={{
                marginBottom: "100px",
              }}
              sx={{ width: "100%", marginTop: "20px" }}
            >
              <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                  <Table
                    sx={{ minWidth: 750 }}
                    aria-labelledby="tableTitle"
                    size={dense ? "small" : "medium"}
                  >
                    <EnhancedTableHead
                      numSelected={selected.length}
                      order={order}
                      orderBy={orderBy}
                      onSelectAllClick={handleSelectAllClick}
                      onRequestSort={handleRequestSort}
                      rowCount={rows.length}
                    />
                    <TableBody>
                      {stableSort(rows, getComparator(order, orderBy))
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.name);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              aria-checked={isItemSelected}
                              tabIndex={-1}
                              key={row.name}
                              selected={isItemSelected}
                            >
                              <TableCell padding="checkbox"></TableCell>
                              <TableCell align="left">
                                {row.name.slice(0, 20).concat("...")}
                              </TableCell>
                              <TableCell align="left">
                                {row.designation}
                              </TableCell>
                              <TableCell align="left">{row.mobile}</TableCell>
                              <TableCell align="left">
                                <Chip
                                  label={
                                    row.is_active === 1 ? "Active" : "Inactive"
                                  }
                                  type={
                                    row.is_active === 1 ? "active" : "inactive"
                                  }
                                />
                              </TableCell>
                              <TableCell align="left">
                                <IconButton
                                  aria-label="edit"
                                  onClick={() => {
                                    openAddModal();
                                    handleSelectBtn("edit");
                                    setCurrentClientContact(row);
                                  }}
                                >
                                  <EditIcon />
                                </IconButton>
                                <SwitchButton
                                  checked={row.is_active}
                                  onClick={() => {
                                    handleChangeActiveStatus(row);
                                  }}
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: (dense ? 33 : 53) * emptyRows,
                          }}
                        >
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={rows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={CustomTablePaginationActions}
                />
              </Paper>
            </Box>
          </>
        ) : (
          <>
            {isLoader ? (
              <LoaderComponent />
            ) : (
              <NodataFound
                onClick={() => {
                  openAddModal();
                  handleSelectBtn("add");
                }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default SearchVendorContactPage;
